/**
 * Типы уведомлений веб-кабинета агента (DEV-1017). Форма совпадает с notifications-service
 * (REST NotificationItem и SSE-событие). Полноценный notification-центр: лента + колокольчик,
 * live-доставка по SSE.
 */

/** Уведомление из API / SSE. */
/**
 * Приложение-адресат уведомления (DEV-1958). Кабинет читает только свои: до
 * разведения сюда попадали и уведомления CRM, и задачи трекера.
 */
export const NOTIFICATION_APP = 'agent_cabinet'

export interface Notification {
  id: string
  notificationType: string
  title: string
  body: string
  metadata: Record<string, unknown>
  channelsSent: string[]
  isRead: boolean
  createdAt: string
  readAt: string | null
  /** Приложение-адресат: для этой ленты всегда agent_cabinet. */
  app: string
  /** Готовая ссылка перехода от бэкенда (DEV-1961). */
  url: string
}

/** Пагинированный ответ списка уведомлений. */
export interface NotificationsListResponse {
  notifications: Notification[]
  total: number
  page: number
  pageSize: number
}

/** Настройка канала уведомлений (страница настроек). */
export interface ChannelPreference {
  channel: string
  enabled: boolean
}

/** Настройка типа событий: отсутствие типа в ответе = включён. */
export interface TypePreference {
  notificationType: string
  enabled: boolean
}
